/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-24 16:42:23
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { DtBrowserModule } from '@ithinkdt/shared/browser';
import { DtI18nModule } from '@ithinkdt/theme/i18n';
import { DtMenuModule } from '@ithinkdt/theme/menu';
import { DtSettingDrawerModule } from '@ithinkdt/theme/setting-drawer';

import { ResetPwdService } from './shared/fetch/service/reset-pwd.service';

import { HeaderComponent } from './header.component';
import { LogoComponent } from './logo/logo.component';
import { NoticeIconTabComponent } from './notify/notice-icon-tab/notice-icon-tab.component';
import { NoticeIconComponent } from './notify/notice-icon/notice-icon.component';
import { NotifyComponent } from './notify/notify.component';
import { SearchComponent } from './search/search.component';
import { BindAccountComponent } from './user/bind-account/bind-account.component';
import { ChangeAccountComponent } from './user/change-account/change-account.component';
import { ResetPwdComponent } from './user/reset-pwd/reset-pwd.component';
import { HeaderUserComponent } from './user/user.component';

const ANGULAR_MODULES = [CommonModule, FormsModule, ReactiveFormsModule, RouterModule];

const THIRD_MODULES = [TranslateModule];

const ANTD_MODULES = [
  NzAvatarModule,
  NzButtonModule,
  NzFormModule,
  NzIconModule,
  NzInputModule,
  NzLayoutModule,
  NzModalModule,
  NzPopoverModule,
  NzToolTipModule,
  NzDropDownModule,
  NzBadgeModule,
  NzTabsModule,
  NzSpinModule,
  NzListModule,
  NzTagModule,
];

const DT_MODULES = [DtBrowserModule, DtI18nModule, DtSettingDrawerModule, DtMenuModule];

const COMPONENTS = [
  HeaderComponent,
  LogoComponent,
  NotifyComponent,
  NoticeIconComponent,
  NoticeIconTabComponent,
  SearchComponent,
  HeaderUserComponent,
  BindAccountComponent,
  ChangeAccountComponent,
  ResetPwdComponent,
];

@NgModule({
  imports: [...ANGULAR_MODULES, ...THIRD_MODULES, ...ANTD_MODULES, ...DT_MODULES],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
  providers: [ResetPwdService],
})
export class DtHeaderModule {}
